import {
  CHANGE_THEME_TO_DARK,
  CHANGE_THEME_TO_LIGHT,
  CHANGE_THEME_TO_SYSTEM,
  SYNC_SYSTEM_THEME,
} from '../actions/themeActions';

const systemIsDark = () => typeof window !== 'undefined'
  && window.matchMedia
  && window.matchMedia('(prefers-color-scheme: dark)').matches;

const storedMode = () => {
  try {
    const value = window.localStorage.getItem('kkutu-admin-theme');
    return ['system', 'dark', 'light'].includes(value) ? value : 'system';
  } catch (e) {
    return 'system';
  }
};

const initialMode = storedMode();
const initialState = {
  mode: initialMode,
  className: initialMode === 'system'
    ? (systemIsDark() ? 'theme-dark' : 'theme-light')
    : `theme-${initialMode}`,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case CHANGE_THEME_TO_DARK:
      return { mode: 'dark', className: 'theme-dark' };
    case CHANGE_THEME_TO_LIGHT:
      return { mode: 'light', className: 'theme-light' };
    case CHANGE_THEME_TO_SYSTEM:
      return { mode: 'system', className: action.dark ? 'theme-dark' : 'theme-light' };
    case SYNC_SYSTEM_THEME:
      return state.mode === 'system'
        ? { ...state, className: action.dark ? 'theme-dark' : 'theme-light' }
        : state;
    default:
      return state;
  }
}
